import { Component, inject, OnInit } from '@angular/core';
import { Header } from './components/header/header';
import { RouterOutlet } from '@angular/router';
import { Banner } from './components/banner/banner';
import { EmilyDrawer } from './components/emily/emily-drawer/emily-drawer';
import { Auth } from '@synegen/utility';
import { ContextHeader } from '../ui-context/context-header/context-header';
import { FloatingEmilyButtonComponent } from './components/emily/floating-emily-button/floating-emily-button';
import { FloatingFileButtonComponent } from './components/file-upload/floating-file-button/floating-file-button';
import { FileDrawer } from './components/file-upload/file-drawer/file-drawer';
import { FileUploaderService } from './services/file-uploader';

@Component({
  selector: 'app-root',
  imports: [
    Header,
    RouterOutlet,
    Banner,
    EmilyDrawer,
    ContextHeader,
    FloatingEmilyButtonComponent,
    FloatingFileButtonComponent,
    FileDrawer,
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  standalone: true,
})
export class App implements OnInit{
  auth: Auth = inject(Auth);
  #fileUploaderService: FileUploaderService = inject(FileUploaderService);

  ngOnInit(): void {
    this.#fileUploaderService.setButtonVisible(true);
  }


}
